import { configureCognito } from '@codespeak11/cognito-passwordless';

const siteOrigin = typeof window !== 'undefined' ? window.location.origin : 'https://cxfab.com';

configureCognito({
  userPoolId: import.meta.env.VITE_USER_POOL_ID || 'us-east-1_PCfRCmOyx',
  clientId: import.meta.env.VITE_SPA_CLIENT_ID || '69o7fe36ijqu9k4koo981r0b1',
  sso: {
    role: 'client',
    portalUrl: import.meta.env.VITE_SSO_PORTAL_URL || 'https://auth.braindance.net',
    cognitoDomain: import.meta.env.VITE_SSO_COGNITO_DOMAIN || 'https://braindance-auth-prod.auth.us-east-1.amazoncognito.com',
    callbackUrl: `${siteOrigin}/auth/callback`,
    signOutUrl: siteOrigin,
    scopes: ['openid', 'email', 'profile'],
  },
});
